const CPF_REGEX = /^[0-9]{11}$/;
const SSN_REGEX =
  /^(?!(000|666|9))[0-9]{3}(-?)(?!00)[0-9]{2}(-?)(?!0000)[0-9]{4}$/;
const ITIN_REGEX =
  /^(?!([9]{3}(-?)[9]{2}(-?)[9]{4}))9[0-9]{2}(-?)[0-9]{2}(-?)[0-9]{4}$/;
const PAN_REGEX = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

const CRS_TAXPAYERID_OPTIONS = {
  ITIN: 'ITIN',
  NO_TAXPAYER_ID: 'NO_TAXPAYER_ID',
  SSN: 'SSN',
  TIN: 'TIN',
} as const;

const TAXID_US_SSN_MAXLEN = 9;
const TAXID_US_ITIN_MAXLEN = 9;
const TAXID_IN_PAN_MAXLEN = 10;
const TAXID_BR_CPF_MAXLEN = 11;
const TAXID_DEFAULT_MAXLEN = 20;

/**
 * US-specific: Individual Taxpayer Identification Numbers (ITIN) always start with '9'.
 * This is used to distinguish between ITIN and SSN for US tax IDs only.
 * Reference: https://www.irs.gov/individuals/individual-taxpayer-identification-number
 */
const ITIN_PREFIX = '9';

/* Key ordering matters for crsTaxDetailsChangeHandler */
/* eslint-disable sort-keys */
const CRS_TAX_DETAILS_FIELDS = {
  COUNTRY_CODE: 'countryCode',
  TAX_PAYER_ID_TYPE: 'taxPayerIdType',
  TAX_PAYER_ID_VALUE: 'taxPayerIdValue',
  NO_TAX_PAYER_ID_REASON: 'noTaxPayerIdReason',
};

/* eslint-enable sort-keys */
type TaxPayerIdMapperType = {
  [key: string]: {
    [key: string]: {
      maxLength: number;
      regex: RegExp;
    };
  };
};

const TAX_PAYER_ID_MAPPER: TaxPayerIdMapperType = {
  BR: {
    TIN: {
      maxLength: TAXID_BR_CPF_MAXLEN,
      regex: CPF_REGEX,
    },
  },
  DEFAULT: {
    TIN: {
      maxLength: TAXID_DEFAULT_MAXLEN,
      regex: /.*/,
    },
  },
  IN: {
    TIN: {
      maxLength: TAXID_IN_PAN_MAXLEN,
      regex: PAN_REGEX,
    },
  },
  US: {
    ITIN: {
      maxLength: TAXID_US_ITIN_MAXLEN,
      regex: ITIN_REGEX,
    },
    SSN: {
      maxLength: TAXID_US_SSN_MAXLEN,
      regex: SSN_REGEX,
    },
  },
};

const FPTI_VALUE_MISSING_ERROR = 'valueMissing';
const FPTI_INVALID_VALUE_ERROR = 'invalidValue';

export {
  CPF_REGEX,
  CRS_TAX_DETAILS_FIELDS,
  CRS_TAXPAYERID_OPTIONS,
  FPTI_INVALID_VALUE_ERROR,
  FPTI_VALUE_MISSING_ERROR,
  ITIN_PREFIX,
  PAN_REGEX,
  SSN_REGEX,
  TAX_PAYER_ID_MAPPER,
  TAXID_BR_CPF_MAXLEN,
  TAXID_DEFAULT_MAXLEN,
  TAXID_IN_PAN_MAXLEN,
  TAXID_US_ITIN_MAXLEN,
  TAXID_US_SSN_MAXLEN,
};
